(() => {
const $1c52d60a8a3c341c$var$lib = {
    selectors: {
        tileCtr: '.customer__tiles',
        tile: '.tile'
    }
};
const $1c52d60a8a3c341c$var$showEl = (el)=>el.hidden = false;
const $1c52d60a8a3c341c$var$hideEl = (el)=>el.hidden = true;
document.addEventListener('mcflyFilterChange', function(event) {
    const tileContainer = document.querySelector($1c52d60a8a3c341c$var$lib.selectors.tileCtr);
    const allTiles = tileContainer.querySelectorAll($1c52d60a8a3c341c$var$lib.selectors.tile);
    allTiles.forEach((tile)=>{
        if (!event.detail.filterValue) $1c52d60a8a3c341c$var$showEl(tile);
        else {
            const tileCategories = tile.getAttribute('data-cat').split(' ');
            !tileCategories.includes(event.detail.filterValue) ? $1c52d60a8a3c341c$var$hideEl(tile) : $1c52d60a8a3c341c$var$showEl(tile);
        }
    });
    Array.from(allTiles).filter((tile)=>!tile.hidden).length === 0 ? $1c52d60a8a3c341c$var$hideEl(tileContainer) : $1c52d60a8a3c341c$var$showEl(tileContainer);
});

})();
//# sourceMappingURL=customer_tiles.min.js.map
